import { LiquidiumMode } from '@plug-core/hooks/useLiquidiumAction'

export const ROUTES = {
  ROOT: '/',
  UNLOCK: '/unlock',

  BACKUP_SEED: '/wallet/backup-seed',
  PEM_IMPORT: '/wallet/import-pem',
  STOIC_IMPORT: '/wallet/import-stoic',

  HOME: '/home',

  // TOKENS
  TOKEN_DETAILS: (tokenId: string) => `/home/tokens/${tokenId}`,
  MANAGE_TOKENS: '/home/tokens/manage',

  ADDRESSES: '/home/addresses',
  MANAGE_EVM: '/home/manage-evm',

  ACCOUNTS: '/home/accounts',
  EDIT_ACCOUNT: (principalId: string) => `/home/accounts/${principalId}/edit`,
  WALLET_IMPORT_TYPE: '/home/accounts/new-type',

  SEND: '/home/send',
  SEND_REVIEW: '/home/send/review',

  SWAP: '/home/swap',
  SWAP_FALLBACK_PROVIDER_SELECT: '/home/swap/fallback/provider-select',
  SWAP_FALLBACK_PAIR_SELECT: '/home/swap/fallback/pair-select',
  ICPSWAP_FALLBACK_PAIR: '/home/swap/fallback/icpswap',

  // NFTS
  NFT_OVERVIEW: '/nfts',
  NFT_DETAILS: (nftCanisterId: string, tokenId: string) =>
    `/nfts/details/${nftCanisterId}/${tokenId}`,

  // CONTACTS
  CONTACTS: '/contacts',
  CONTACT_DETAILS: (id: string) => `/contacts/${id}`,

  // SETTINGS
  SETTINGS: '/settings',
  SETTINGS_NETWORKS: '/settings/networks',
  SETTINGS_HELP: '/settings/help',
  SETTINGS_RECOVERY_PHRASE: '/settings/recovery-phrase',
  SETTINGS_PEM_EXPORT: '/settings/pem-export',
  LOCALE_SETTINGS: '/settings/locale',
  KEY_REVEAL_ACCEPTANCE: '/settings/key-reveal-acceptance',
  CONNECTED_APPS: '/settings/connected-apps',
  DEVELOPER_SETTINGS: '/settings/developer-settings',
  DEVELOPER_SETTINGS_NETWORKS: '/settings/developer-settings/networks',
  DEVELOPER_SETTINGS_NEW_NETWORK: '/settings/developer-settings/networks/new',
  DEVELOPER_SETTINGS_EDIT_NETWORK: (id: string) =>
    `/settings/developer-settings/network/${id}/edit`,

  // DeFi hub
  DEFI_HUB: '/defi',
  STAKE: '/defi/stake',
  EARN: '/defi/earn',
  EARN_VAULTS: '/defi/earn/vaults',
  EARN_DEPOSIT: '/defi/earn/deposit',
  EARN_WITHDRAW: '/defi/earn/withdraw',
  TOPUP: '/defi/topup',
  TOPUP_HISTORY: '/defi/topup/history',
  MINT_CYCLES: '/defi/mint-cycles',
  APPROVE_CYCLES: '/defi/approve-cycles',
  MINT: '/defi/mint',
  MINT_BTC: '/defi/mint-btc',
  BORROW_LEND: '/defi/borrowlend',
  FUND_BORROW_LEND: (mode: LiquidiumMode, asset?: string) =>
    `/defi/borrowlend/${mode}${asset ? `?asset=${encodeURIComponent(asset)}` : ''}`,

  // Perps
  PERPS: '/perps',
  PERP_DETAILS: (hyperliquidTokenId: string) => `/perps/details/${hyperliquidTokenId}`,

  USER_ACTIVITY: '/user-activity',
  AUTHORIZE: '/authorize',
  LLM_CHAT: '/llm-chat',
  DISCOVER: '/discover',
}
